import { EventContext } from "@/domains/metrics/context";
import { toastModule } from "@/modules/toast";
import { AppStore } from "@/store";
import { CollectionObservable } from "@/store/collections/CollectionObservable";
import { INoteObservable } from "@/store/note";
import { TemplateObservable } from "@/store/templates/TemplateObservable";

export const addNotesToCollection = async ({
  notes,
  collection,
  store,
  eventContext,
}: {
  notes: (INoteObservable | TemplateObservable)[];
  collection: CollectionObservable;
  store: AppStore;
  eventContext: EventContext;
}) => {
  if (!notes.length) return;

  await Promise.all(
    notes.map(note =>
      collection.itemList.addItem({
        itemId: note.id,
        itemKind: note instanceof TemplateObservable ? "TEMPLATE" : "NOTE",
        triggerSuccessToast: false,
        eventContext,
      })
    )
  );

  const isTemplate = notes[0] instanceof TemplateObservable;
  const itemType = isTemplate
    ? notes.length === 1
      ? "Template"
      : "Templates"
    : notes.length === 1
      ? "Note"
      : "Notes";

  toastModule.triggerToast({
    content: (
      <div>
        {`${itemType} added to `}
        <a onClick={() => store.navigation.goToCollection({ collectionId: collection.id })}>
          {collection.label}
        </a>
        {"."}
      </div>
    ),
  });
};
